import { EColors, type Colors } from '@/types/constants/ColorValues'

export type AlertState = {
    type: Colors
    message: string
}

export enum EAlertActions {
    CLEAR = 'clear',
    ERROR = EColors.DANGER,
    INFO = EColors.INFO,
    LIGHT = EColors.LIGHT,
    PRIMARY = EColors.PRIMARY,
    SUCCESS = EColors.SUCCESS,
    WARNING = EColors.WARNING,
    QUEUE_ITEM = 'queueItem'
}

export enum EAlertMutations {
    CLEAR = 'clear',
    ERROR = EColors.DANGER,
    INFO = EColors.INFO,
    LIGHT = EColors.LIGHT,
    PRIMARY = EColors.PRIMARY,
    SUCCESS = EColors.SUCCESS,
    WARNING = EColors.WARNING,
    ADD_TO_QUEUE = 'addToQueue',
    REMOVE_FROM_QUEUE = 'removeFromQueue'
}
